import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const SKELETON_COLORS = {
  /** Dark theme default — used on dark backgrounds (redesign glassmorphic UI) */
  bone: 'rgba(255, 255, 255, 0.06)',
  /** Slightly more visible variant for small mobile screens */
  boneMobile: 'rgba(255, 255, 255, 0.08)',
  /** Light theme variant — used on white/light card backgrounds */
  boneLight: '#E5E7EB',
} as const;

/** Returns the correct skeleton bone color for the current theme. */
export function useSkeletonBoneColor(): string {
  const { mode } = useThemeColors();
  return mode === 'light' ? SKELETON_COLORS.boneLight : SKELETON_COLORS.bone;
}
